import useAgentData from '~/client/hooks/useAgentData';
import useCurrentUser from '~/client/hooks/user/useCurrentUser';
import useSite from '~/client/hooks/useSite';
import { useProvidersListQuery } from './graphql/ProvidersListQuery.generated';

const useProviders = () => {
  const { walletCurrency } = useCurrentUser();
  const { site } = useSite();
  const { deviceType } = useAgentData();

  const variables = {
    filter: {
      currency: walletCurrency,
      site,
      section: 1,
    },
    menuItemsFilter: { type: deviceType },
  };

  const { data, loading } = useProvidersListQuery({
    variables,
  });

  const validProviders = data?.casino?.ProvidersConnection?.edges
    ?.map(({ node }) => node)
    ?.filter((node) => node?.games?.totalCount);

  return { loading, providers: validProviders };
};

export default useProviders;
